import store from '@/store';

const translate = (key: string) => store.getters.translate(key);

export {
  // eslint-disable-next-line import/prefer-default-export
  translate,
};
